<template>
  <transition name="modal" mode="out-in">
    <section class="modal-container" v-if="isDisplayed.display">
      <div class="modal-content">
        <h1>ACCESS</h1>
        <h1 v-if="isDisplayed.isGranted" class="access-granted">GRANTED</h1>
        <h1 v-if="!isDisplayed.isGranted" class="access-denied">DENIED</h1>
      </div>
    </section>
  </transition>
</template>

<script>
export default {
  name: "Access-Modal",
  data() {
    return {};
  },
  computed: {
    isDisplayed() {
      return this.$store.state.isModalDisplayed;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/css/Scheme.scss";
.modal-container {
  position: fixed;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  left: 0;
  height: 100%;
  width: 50%;
  background-color: white;
  .modal-content {
    width: 100%;
    background-color: white;
    padding-right: 1.5em;
    font-size: 1.75em;
    text-align: right;
    letter-spacing: 2px;
    h1 {
      color: black;
      margin: 0;
    }
    h1 + h1 {
      margin-top: 1em;
    }
    .access-granted {
      color: green;
    }
    .access-denied {
      color: red;
    }
    @media screen and (max-width: 400px) {
      font-size: 1em;
    }
  }
}
.modal-enter-active,
.modal-leave-active {
  transition: all 0.5s ease-out;
}
.modal-enter {
  transform: translate(-100%, 0);
}
.modal-leave-to {
  transform: translate(-100%, 0);
}
</style>
